import { BrandLogo } from "@/components/ui/brand-logo"
import { Button } from "@/components/ui/button"
import { t } from "@/lib/i18n"

import type { LandingLinks } from "./types"

const navItems = [
  { key: "self_service", href: "#self-service" },
  { key: "product", href: "#product" },
  { key: "pricing", href: "#pricing" },
  { key: "audience", href: "#audience" },
]

export function LandingHeader({ links }: { links: LandingLinks }) {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/85 backdrop-blur-xl">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-6 px-4 py-3">
        <a href="#top" className="flex items-center" aria-label={t("ui.app.name")}>
          <BrandLogo variant="lockup" className="h-7 text-brand-solid" title={null} />
        </a>

        <nav className="hidden items-center gap-7 text-sm font-medium text-muted-foreground md:flex">
          {navItems.map((item) => (
            <a key={item.key} className="transition-colors hover:text-foreground" href={item.href}>
              {t(`ui.landing.nav.${item.key}`)}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button variant="ghost" asChild className="hidden sm:inline-flex">
            <a href={links.staffSignIn}>{t("ui.landing.nav.sign_in")}</a>
          </Button>
          <Button asChild>
            <a href={links.staffRegistration}>{t("ui.landing.nav.start")}</a>
          </Button>
        </div>
      </div>
    </header>
  )
}
